function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.3,
  d: "M23.928 12.066c0-6.38-5.173-11.554-11.554-11.554C5.994.512.82 5.686.82 12.066S5.994 23.62 12.374 23.62l.204-.003v-8.994h-2.483V11.73h2.482V9.601c0-2.469 1.508-3.813 3.71-3.813 1.055 0 1.961.08 2.226.114v2.58h-1.52c-1.197 0-1.43.57-1.43 1.405v1.843h2.866l-.374 2.893h-2.491v8.55c4.83-1.384 8.364-5.833 8.364-11.107z",
  fill: "#fff"
});

var SvgFb = function SvgFb(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNMjMuOTI4NSAxMi4wNjU4QzIzLjkyODUgNS42ODU2NSAxOC43NTQ2IDAuNTExNzE5IDEyLjM3NDQgMC41MTE3MTlDNS45OTQyNCAwLjUxMTcxOSAwLjgyMDMxMiA1LjY4NTY1IDAuODIwMzEyIDEyLjA2NThDMC44MjAzMTIgMTguNDQ2IDUuOTk0MjQgMjMuNjE5OSAxMi4zNzQ0IDIzLjYxOTlDMTIuNDQyMyAyMy42MTk5IDEyLjUwOTggMjMuNjE4NSAxMi41Nzc1IDIzLjYxNzNWMTQuNjIyOUgxMC4wOTUyVjExLjczSDEyLjU3NzVWOS42MDExM0MxMi41Nzc1IDcuMTMyMiAxNC4wODQ3IDUuNzg4NDMgMTYuMjg3MSA1Ljc4ODQzQzE3LjM0MTcgNS43ODg0MyAxOC4yNDgzIDUuODY3MDYgMTguNTEyNSA1LjkwMjE0VjguNDgyNUgxNi45OTM5QzE1Ljc5NTcgOC40ODI1IDE1LjU2MzcgOS4wNTE5NSAxNS41NjM3IDkuODg3NDRWMTEuNzNIMTguNDI4NkwxOC4wNTUyIDE0LjYyMjlIMTUuNTYzN1YyMy4xNzM1QzIwLjM5MzIgMjEuNzg5IDIzLjkyODUgMTcuMzM5NyAyMy45Mjg1IDEyLjA2NThaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgFb as ReactComponent };